import React, { FC, HTMLProps } from 'react';
import cn from 'classnames';
import styles from './FilledArrow.module.scss';

interface OwnProps extends HTMLProps<HTMLButtonElement> {
  direction: 'left' | 'right';
}

const StudioArrow: FC<OwnProps> = ({ className, direction, onClick }) => {
  const rotate = direction === 'right' ? 0 : 180;

  return (
    <button className={cn(className, styles.arrow)} onClick={onClick}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${rotate}deg)` }}
      >
        <rect width="48" height="48" rx="24" fill="white" />
        <path
          d="M20.7 29.3C20.5167 29.1167 20.425 28.8833 20.425 28.6C20.425 28.3167 20.5167 28.0833 20.7 27.9L24.6 24L20.7 20.1C20.5167 19.9167 20.425 19.6833 20.425 19.4C20.425 19.1167 20.5167 18.8833 20.7 18.7C20.8833 18.5167 21.1167 18.425 21.4 18.425C21.6833 18.425 21.9167 18.5167 22.1 18.7L26.7 23.3C26.8 23.4 26.871 23.5083 26.913 23.625C26.9543 23.7417 26.975 23.8667 26.975 24C26.975 24.1333 26.9543 24.2583 26.913 24.375C26.871 24.4917 26.8 24.6 26.7 24.7L22.1 29.3C21.9167 29.4833 21.6833 29.575 21.4 29.575C21.1167 29.575 20.8833 29.4833 20.7 29.3Z"
          fill="#383838"
        />
      </svg>
    </button>
  );
};

export default StudioArrow;
